module.exports = __webpack_public_path__ + "static/media/icon-arrow-left-light-blue.dfdbf867.svg";